export enum MessageStatus {
  Delivered = 0,
  Queued = 1,
  Sending = 2,
  Sent = 3,
  Failed = 4,
  Undelivered = 5,
  Receiving = 6,
  Received = 7,
  Accepted = 8,
  Scheduled = 9,
  PartiallyDelivered = 10,
}

export const MessageStatusEnum = {
  delivered: { key: 'delivered', value: MessageStatus.Delivered, text: 'Delivered' },
  queued: { key: 'queued', value: MessageStatus.Queued, text: 'Queued' },
  sending: { key: 'sending', value: MessageStatus.Sending, text: 'Sending' },
  sent: { key: 'sent', value: MessageStatus.Sent, text: 'Sent' },
  failed: { key: 'failed', value: MessageStatus.Failed, text: 'Failed' },
  undelivered: { key: 'undelivered', value: MessageStatus.Undelivered, text: 'Undelivered' },
  receiving: { key: 'receiving', value: MessageStatus.Receiving, text: 'Receiving' },
  received: { key: 'received', value: MessageStatus.Received, text: 'Received' },
  accepted: { key: 'accepted', value: MessageStatus.Accepted, text: 'Accepted' },
  scheduled: { key: 'scheduled', value: MessageStatus.Scheduled, text: 'Scheduled' },
  partiallyDelivered: { key: 'partially_delivered', value: MessageStatus.PartiallyDelivered, text: 'Partially Delivered' },
};
